import request from '@/utils/axios/request'
const isDevelopment = process.env.NODE_ENV === 'development'
const HOST = window.location.origin
const PREFIX = isDevelopment ? '' : `${HOST}/api/uc`
interface PhoneCodeParams {
    mobile: string
    usage: string
    terminal?: string
    countryCode?: string
}
interface VerifyMobileCodeParams {
    mobile: string
    verifyCode: string
    usage: string
    countryCode?: string
}
interface LoginParams {
    verifyCode?: string
    password?: string
    rememberMe?: boolean
    phone?: string
    account?: string
    channel?: string
    mobile: string
    terminal: string
    backUrl: string
    countryCode?: string
}
interface VerifyPasswordParams {
    mobile: string
    password: string
    channel?: string
    userId?: string
    corpId?: string
    countryCode?: string
}
interface setPwdParams {
    mobile: string
    password: string
    usage: string
    authCode: string
    countryCode?: string
}
interface registerParams {
    mobile: string,
    countryCode?: string
}
interface setUsernameParams {
    mobile: string,
    name: string,
    countryCode?: string
}
interface checkPwdStatusParams {
    mobile: string,
    pwd: string,
    terminal?: string,
    countryCode?: string
}

interface WechatBindAccountParams {
    mobile: string,
    smsCode: string,
    unionId: string,
    redirectURL: string,
    countryCode?: string
}

const loginService = {
    initializeVerifyLoginStatus(service: string) {
        const queryPath = service ? `?service=${service}`: ''
        return request.get(`${PREFIX}/login/validate${queryPath}`)
    },
    sendPhoneCode(params: PhoneCodeParams) {
        return request.post(`${PREFIX}/sms`, params)
    }, 
    verifyMobileCode(params: VerifyMobileCodeParams) {
        return request.post(`${PREFIX}/sms/verification`, params)
    },
    verifyPassword(params: VerifyPasswordParams) {
        return request.post('/v1/login/account/verification', params)
    },
    login(params: LoginParams) {
        return request.post(`${PREFIX}/login`, params)
    },
    setpassword(params: setPwdParams) {
        return request.post(`${PREFIX}/user/password/initial`, params)
    },
    checkLoginStatus(account: string, terminal: string) {
        const query = terminal?`?terminal=${terminal}`:''
        return request.get(`${PREFIX}/user/${account}/login/status${query}`)
    },
    checkAccountStatus(account: string) {
        console.log(account, PREFIX)
        return request.get(`${PREFIX}/user/account/status?mobile=${account}`)
    },
    register(params: registerParams) {
        return request.post(`${PREFIX}/user/regist`, params)
    },
    setUsername(params: setUsernameParams) {
        return request.post(`${PREFIX}/user/setName`, params)
    },
    setKickStatus(mobile: string, params: any) {
        return request.post(`${PREFIX}/user/${mobile}/kick/status`, params)
    }, 
    checkPwdStatus(params: checkPwdStatusParams) {
        return request.post(`${PREFIX}/user/checkPwd`, params)
    },
    wechatBindAccount(params: WechatBindAccountParams) {
        return request.get(`${PREFIX}/wechat/bind/account`, params)
    }
}
export default loginService
